import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { ElLoading } from 'element-plus';
import {
  ElAlert,
  ElDatePicker,
  ElDescriptions,
  ElDescriptionsItem,
  ElDrawer,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElButton,
  ElDialog,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElOption,
  ElProgress,
  ElSelect,
  ElSkeleton,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTabPane,
  ElTabs,
  ElTree,
} from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import './styles/tokens.css';
import './styles/main.css';

const ossHost = 'http://xb-agent-box.oss-cn-hangzhou.aliyuncs.com/image';
const app = createApp(App);
const components = [
  ElAlert,
  ElDatePicker,
  ElDescriptions,
  ElDescriptionsItem,
  ElDrawer,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElButton,
  ElDialog,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElOption,
  ElProgress,
  ElSelect,
  ElSkeleton,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTabPane,
  ElTabs,
  ElTree,
];

components.forEach((component) => app.component(component.name!, component));
app.directive('loading', ElLoading.directive);
app.config.globalProperties.ossHost = ossHost;
app.use(createPinia()).use(router).mount('#app');
